import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import React from "react";

interface CheckBoxProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: CheckBoxState;
    settings: any;
}

export class ReactCheckbox extends React.Component<CheckBoxProps, any>{
    handleChange = (event) => {
        var checked = Number(event.target.checked);
        this.props.onTextChange(this.props.settings.name, checked);
    }

    render() {
        var checkBox = null;

        if (this.props.settings.labelPosition == 'right') {
            checkBox = <CheckboxLabelRight label={this.props.settings.label} value={this.props.values[this.props.settings.name]} onChange={this.handleChange} />;
        }
        else {
            checkBox = <CheckboxLabelTop label={this.props.settings.label} value={this.props.values[this.props.settings.name]} onChange={this.handleChange} />
        }
        return (
            <react_components.ReactColumn width={this.props.metadataSettings.width}>
                {checkBox}
            </react_components.ReactColumn>);
    }
};

class CheckboxLabelRight extends React.Component<any, any>{
    render() {
        return (
            <div className="checkbox-inline">
                <label>{this.props.label}
                    <input type="checkbox" checked={this.props.value == 1} onChange={this.props.onChange} />
                </label>
            </div>
        );
    }
};

class CheckboxLabelTop extends React.Component<any, any>{
    render() {
        return (
            <div className="form-group">
                <label>{this.props.label}</label>
                <input type="checkbox" checked={this.props.value == 1} className="checkbox" onChange={this.props.onChange} />
            </div>
        );
    }
};

export class CheckBoxState extends propertyTypes.BaseComponentProps {
    private labelMetadata = new propertyTypes.TranslatableTextProperty("label", "Label");
    public label: string;

    private labelPositionMetadata = new propertyTypes.SelectProperty("labelPosition", "Label position").addOption("top", "Top").addOption("right", "Right");
    public labelPosition: string;

    private isMandatoryMetadata = new propertyTypes.CheckBoxProperty("isMandatory", "Is mandatory?");
    public isMandatory: string;

    private checkBoxMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.getNameMetadata().SetMandatory(true);
        const baseMetaData = super.getMetadata();
        this.checkBoxMetadata = baseMetaData.concat([this.labelMetadata, this.labelPositionMetadata, this.isMandatoryMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.checkBoxMetadata;
    }
}